import { useEffect } from 'react';

/**
 * Đếm số hộp thoại đang mở.
 *
 * Hộp thoại lồng nhau là chuyện thường ở app này: hộp "Sửa thành viên" mở thêm
 * `HopXacNhan` để xác nhận khoá/xoá. Nếu mỗi hộp tự đặt rồi tự trả
 * `body.overflow`, hộp con đóng trước sẽ trả scroll về trong khi hộp cha còn mở.
 * Nên chỉ hộp **đầu tiên** khoá và chỉ hộp **cuối cùng** mở lại.
 */
let soHopDangMo = 0;
let overflowCu = '';
let paddingCu = '';

function khoa() {
  soHopDangMo += 1;
  if (soHopDangMo > 1) return;

  const than = document.body;
  overflowCu = than.style.overflow;
  paddingCu = than.style.paddingRight;

  /*
   * Bù đúng bề rộng thanh cuộn vừa biến mất, nếu không cả trang nhảy ngang một
   * nhịp lúc mở hộp thoại. Trên máy có thanh cuộn phủ (macOS, điện thoại) hiệu
   * số bằng 0 nên không bù gì.
   */
  const beRongThanhCuon = window.innerWidth - document.documentElement.clientWidth;
  than.style.overflow = 'hidden';
  if (beRongThanhCuon > 0) than.style.paddingRight = `${String(beRongThanhCuon)}px`;
}

function moLai() {
  soHopDangMo = Math.max(0, soHopDangMo - 1);
  if (soHopDangMo > 0) return;

  document.body.style.overflow = overflowCu;
  document.body.style.paddingRight = paddingCu;
}

/**
 * Khoá cuộn trang nền trong suốt thời gian component còn sống.
 *
 * Dùng trong mọi hộp thoại và drawer: không khoá thì cuộn chuột trên lớp phủ
 * làm trang sau trượt đi, và hộp cao hơn màn hình đẩy cả trang dài ra.
 */
export function useKhoaCuonTrang(): void {
  useEffect(() => {
    khoa();
    return moLai;
  }, []);
}
